export default {
  0: 'IDaaS 認定クラウドのメリット - 顧客ケース - 企業 ID 管理 - 読み方 - オープン ソース ソリューション',
};
